import React from 'react'

import { transformImage } from 'src/lib/images'

import HeadingLevel from '../Heading/Heading'

export type PromoPreviewProps = {
  headerText: string
  paragraphText: string
  buttonText: string
  onClickPromo?: () => void
  backgroundImageUrl: string
  buttonClass?: string
}

const PromoPreview: React.FC<PromoPreviewProps> = ({
  headerText,
  paragraphText,
  buttonText,
  onClickPromo,
  backgroundImageUrl,
  buttonClass = '',
}) => {
  const getBackgroundImage = () => {
    if (backgroundImageUrl) {
      return transformImage({
        imageUrl: backgroundImageUrl,
        options: { height: 210, width: 482 },
      })
    }
    return '../../../assets/fallback-images/16x9.png'
  }
  const promoStyle = {
    backgroundImage: `url(${encodeURI(getBackgroundImage())})`,
    backgroundSize: 'cover',
    maxWidth: '482px',
    width: '100%',
    height: '210px',
  }

  return (
    <div
      className="ring-3 flex items-center rounded-lg border border-gray-300 bg-gray-50 shadow-lg ring-gray-900 ring-opacity-30"
      style={promoStyle}
    >
      <div className="w-1/2 p-4">
        <div className="pt-6">
          <HeadingLevel level={2} levelStyle={3} className="text-white">
            {headerText}
          </HeadingLevel>
        </div>
        <div className="pb-5 pt-2 text-xs text-white">{paragraphText}</div>
        <div className="pb-6">
          <button
            className={`${buttonClass} rounded-md bg-lime-400 px-6 py-1.5 text-xs font-medium text-black hover:hover:bg-lime-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600`}
            aria-label={buttonText}
            onClick={onClickPromo}
          >
            {buttonText}
          </button>
        </div>
      </div>
    </div>
  )
}

export default PromoPreview
